// Shared segmented control used to switch between an operational view and its history.
// Compact, on-brand (dark-green active pill on a cream track), mobile-friendly.
export function ViewTabs({ value, onChange, options, className = "" }) {
  return (
    <div role="tablist" className={`inline-flex items-center gap-1 rounded-lg border border-[#E5DEC9] bg-white p-1 w-fit ${className}`}>
      {options.map((o) => (
        <button
          key={o.value}
          role="tab"
          type="button"
          aria-selected={value === o.value}
          data-testid={o.testid}
          onClick={() => onChange(o.value)}
          className={`rounded-md px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${
            value === o.value ? "bg-[#1B3B2B] text-white" : "text-[#1B3B2B] hover:bg-[#F0EAE1]"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
